module.exports = __webpack_public_path__ + "static/media/4ODA12.4c18fe6a.jpg";